/**
 * Takes in input number and caps it to a certain number of decimal places
 *
 * This is different to toFixed, as toFixed ALWAYS rounds to input decimal place.
 * Instead, this function will only cap the number of decimal places if it exceeds the input.
 */
export default function capNumberToDecimal(value: string | number, fractionDigits = 2): string {
  let cappedString = value.toString();

  const [whole, decimal] = cappedString.split('.');

  if (decimal?.length > fractionDigits) {
    cappedString = whole + '.' + decimal.slice(0, fractionDigits);
  }

  return cappedString;
}
